<template>
  <el-dialog
    :visible.sync="visible"
    title="个人信息"
    width="700px"
    append-to-body
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <el-form :model="userInfo">
      <el-form-item
        label="账号"
        :label-width="formLabelWidth"
        class="account-wp"
      >
        <span>{{ userInfo.account }}</span>
      </el-form-item>
      <el-form-item
        v-if="!login"
        label="姓名"
        :label-width="formLabelWidth"
        required
      >
        <b-form-input
          v-model="userInfo.name"
          autocomplete="off"
          placeholder="请输入姓名"
          :class="{ 'is-invalid': verify.name }"
        ></b-form-input>
        <div class="invalid-feedback">
          <span>{{ verify.name }}</span>
        </div>
      </el-form-item>
      <el-form-item
        v-if="!login"
        label="邮箱"
        :label-width="formLabelWidth"
        required
      >
        <b-form-input
          v-model="userInfo.email"
          autocomplete="off"
          placeholder="请输入邮箱"
          :class="{ 'is-invalid': verify.email }"
        >
        </b-form-input>
        <div class="invalid-feedback">
          <span>{{ verify.email }}</span>
        </div>
      </el-form-item>
      <el-form-item label="密码" :label-width="formLabelWidth">
        <b-form-input
          v-model="userInfo.password"
          autocomplete="off"
          type="password"
          @input="checkPassword"
          placeholder="最低8位，至少1大写字母、1小写字母、1数字、1英文符号"
          :class="{ 'is-invalid': verify.password }"
        >
        </b-form-input>
        <div class="invalid-feedback">
          <span>{{ verify.password }}</span>
        </div>
      </el-form-item>
      <el-form-item label="确认密码" :label-width="formLabelWidth">
        <b-form-input
          v-model="userInfo.passwordConfirmation"
          autocomplete="off"
          type="password"
          placeholder="请输入确认密码"
          @input="checkRepeatPassword"
          :class="{ 'is-invalid': verify.passwordConfirmation }"
        ></b-form-input>
        <div class="invalid-feedback">
          <span>{{ verify.passwordConfirmation }}</span>
        </div>
      </el-form-item>
      <el-form-item label="手机" :label-width="formLabelWidth">
        <div class="phone-wp">
          <div style="flex-grow: 1">
            <b-form-input
              v-model="userInfo.phone"
              autocomplete="off"
              placeholder="请输入手机号"
              :disabled="login"
              :class="{ 'is-invalid': verify.phone }"
            ></b-form-input>
            <div class="invalid-feedback">
              <span>{{ verify.phone }}</span>
            </div>
          </div>
          <el-button
            type="primary"
            plain
            @click="getPhoneCode"
            style="align-self: flex-start"
            :disabled="sendMsgDisabled"
          >
            <span v-if="!sendMsgDisabled">获取验证码</span>
            <span v-else>{{ codeTime }}s后重新获取</span>
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="验证码" :label-width="formLabelWidth" required>
        <el-input
          v-model="userInfo.verifyCode"
          autocomplete="off"
          placeholder="请输入验证码"
          :class="{ 'is-invalid': verify.verifyCode }"
        ></el-input>
        <div class="invalid-feedback">
          <span>{{ verify.verifyCode }}</span>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeModal">取 消</el-button>
      <el-button size="small" type="primary" @click="update">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import account from "../../server/api/account";
import Vue from "vue";
import auth from "../../server/api/auth";
import { getTimeNow, passwordValidate } from "@/util/fun.js";

export default {
  components: {},
  props: {
    login: {
      //登录时修改密码
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.$emit("close", {});
      }
    },
  },
  data() {
    return {
      visible: false,
      formLabelWidth: "100px",
      userInfo: {
        id: 0,
        account: "",
        name: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        phone: "",
        verifyCode: "",
      },
      verify: {},
      httpError: "",
      codeTime: 29,
      sendMsgDisabled: false,
    };
  },
  mounted() {},
  methods: {
    showModal(user) {
      this.userInfo = {
        id: user.id,
        account: user.username,
        name: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        phone: user.phone,
        verifyCode: "",
      };
      this.visible = true;
      // this.getUserInfo();
    },
    closeModal() {
      this.visible = false;
    },
    closeDialog() {
      //登录时使用的
      this.$emit("change", "");
    },
    getUserInfo() {
      var params = {
        id: this.userInfo.id,
      };
      account.detail(params).then((resp) => {
        if (resp.code === 0) {
          let obj = {};
          obj.account = resp.data.name;
          obj.name = resp.data.realName;
          obj.email = resp.data.email;
          obj.phone = resp.data.phone;
          obj.id = this.userInfo.id;
          this.userInfo = obj;
        }
      });
    },
    // 修改
    update() {
      this.verify = {};

      if (!this.userInfo.name && !this.login) {
        this.verify.name = "请输入姓名";
        return false;
      }
      if (!this.userInfo.email && !this.login) {
        this.verify.email = "请输入邮箱号";
        return false;
      }
      if (this.userInfo.password) {
        if (!passwordValidate(this.userInfo.password, 8)) {
          this.verify.password =
            "最低8位，至少1大写字母、1小写字母、1数字、1英文符号";
          return false;
        }
        if (!this.userInfo.passwordConfirmation) {
          this.verify.passwordConfirmation = "请输入确认密码";
          return false;
        }
      }
      if (this.userInfo.passwordConfirmation) {
        if (this.userInfo.password !== this.userInfo.passwordConfirmation) {
          this.verify.passwordConfirmation = "密码不一致";
          return false;
        }
      }
      if (!this.userInfo.verifyCode) {
        this.verify.verifyCode = "请输入验证码";
        return false;
      }
      let data = {
        adminId: this.userInfo.id,
        realName: this.userInfo.name,
        email: this.userInfo.email,
        newPassword: this.userInfo.password,
        // phone: this.userInfo.phone,
        verifyCode: this.userInfo.verifyCode,
      };
      if (data.newPassword) {
        data.lastChangeTime = getTimeNow(); //密码修改时间
      }
      if (this.login) {
        //登录修改密码不改邮箱和姓名
        delete data.realName;
        delete data.email;
      }
      account.adminUpdate(data).then((resp) => {
        if (resp.code === 0) {
          Vue.swal({
            icon: "success",
            title: "修改成功",
            showConfirmButton: false,
            timer: 1000,
          });
          this.closeModal();
        } else {
          Vue.swal({
            icon: "error",
            title: resp.msg,
            showConfirmButton: false,
            timer: 1000,
          });
        }
      });
    },
    checkPassword(str) {
      let result = passwordValidate(str, 8);
      if (!result) {
        this.verify.password =
          "最低8位，至少1大写字母、1小写字母、1数字、1英文符号";
      } else {
        this.verify.password = "";
      }
    },
    checkRepeatPassword(str) {
      if (!str) {
        this.verify.passwordConfirmation = "请输入确认密码";
      }
      if (str !== this.userInfo.password) {
        this.verify.passwordConfirmation = "密码不一致";
      } else {
        this.verify.passwordConfirmation = "";
      }
    },
    getPhoneCode() {
      let _this = this;
      console.log("phone", this.userInfo.phone);
      if (!this.userInfo.phone) {
        this.verify.phone = "请输入手机号";
        return false;
      } else {
        delete this.verify.phone;
      }
      let params = {
        phone: this.userInfo.phone,
      };
      auth.sendMsg(params).then((resp) => {
        if (resp.code === 0) {
          this.sendMsgDisabled = true;
          let codeInterval = window.setInterval(function() {
            if (_this.codeTime-- <= 0) {
              _this.codeTime = 29;
              _this.sendMsgDisabled = false;
              window.clearInterval(codeInterval);
            }
          }, 1000);
        } else {
          Vue.swal({
            icon: "error",
            title: resp.msg,
            showConfirmButton: false,
            timer: 1000,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  max-height: 80vh;
  overflow-y: auto;
}
::v-deep .el-dialog__body {
  padding: 0 20px 0 0;
}
::v-deep .el-dialog__header {
  padding: 25px 20px 25px;
}
.phone-wp {
  display: flex;
  align-items: center;
}
.phone-wp .el-button {
  flex-shrink: 0;
  margin-left: 10px;
}
.invalid-feedback {
  position: absolute !important;
  line-height: 14px;
  font-size: 12px;
}
</style>
